import _ from 'lodash';

const defaultGA = {
	uid: null,
	profession: null,
	postcode: null,
};

export function fetchDataError(bool) {
	return {
		type: 'FETCH_ERROR',
		hasErrored: bool,
	};
}

export function fetchDataLoading(bool) {
	return {
		type: 'FETCH_LOADING',
		isLoading: bool,
	};
}

export function fetchDataSuccess(json) {
	return {
		type: 'FETCH_SUCCESS',
		json,
	};
}

export function fetchData(urls) {
	return (dispatch) => {
		dispatch(fetchDataLoading(true));

		const promisesArray = Object.keys(urls).map((key) => {
			return fetch(urls[key]);
		});

		Promise.all(promisesArray)
			.then((responses) => {
				responses.map((res) => {
					if (!res.ok) {
						throw Error(res.statusText);
					}
				});
				return responses;
			})
			.then((responses) => {
				return Promise.all(responses.map((res) => res.json()));
			})
			.then((data) => {
				const obj = {};
				Object.keys(urls).map((key, i) => {
					obj[key] = data[i];
				});

				// remove sub regions from geoJSON
				for (let feature of obj.geoJSON.features) {
					if (feature.properties.iso_a2 === 'FR') {
						// remove french regions that arnt central france
						const france = feature.geometry.coordinates[9];
						feature.geometry.coordinates = [];
						feature.geometry.coordinates.push(france);
					}
				}

				// If empty, create fake ga
				const hasGa = _.get(obj, 'data.ga', false);
				if (!hasGa) {
					obj.data.ga = defaultGA;
				}

				dispatch(fetchDataSuccess(obj));
				dispatch(fetchDataLoading(false));
			})
			.catch(() => {
				return dispatch(fetchDataError(true));
			});
	};
}

export function hoverFeatured(country) {
	return {
		type: 'HOVER_FEATURED',
		country,
	};
}

export const setSelectedDisease = (disease) => {
	return {
		type: 'SET_SELECTED_DISEASE',
		disease,
	};
};

export const setPrevalenceSelectedCountry = (country, lat, lng) => {
	return {
		type: 'SET_PREVALENCE_SELECTED_COUNTRY',
		country,
		lat,
		lng,
	};
};
